import React from 'react';
import useKnowledgebases from '../../../hooks/use-knowledgebases';
import useKnowledgebaseCategories from '../../../hooks/use-knowledgebase-categories';
import KnowledgebaseGrid from '../../@knowledgebase/knowledgebase-grid';

interface Props {
  value: string;
}

const SearchKnowledgebaseResults: React.FC<Props> = ({ value }) => {
  const { data, loading, error } = useKnowledgebases(
    process.env.SITE!,
    value,
    '',
    0,
    10
  );

  const {
    data: data1,
    loading: loading1,
    error: error1,
  } = useKnowledgebaseCategories(process.env.SITE!);

  const component = (children) => (
    <section className="search-knowledgebase-results">
      <h3>Knowledgebase</h3>
      {children}
      {/* language=CSS */}
      <style jsx>{`
        section {
          margin-bottom: 2rem;
        }

        h3 {
          font-family: 'Volvo Novum', sans-serif;
          font-weight: 500;
          margin: 0 0 0.5rem;
        }

        .search-knowledgebase-results :global(p) {
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
          margin: 0;
        }
      `}</style>
    </section>
  );

  if (loading || error || loading1 || error1) {
    return component(<p>Searching...</p>);
  }

  if (!data || data.knowledgebases.content.length === 0 || !data1) {
    return component(
      <p>
        Your search did not return any matching knowledge base articles. Please
        try a different search.
      </p>
    );
  }

  return component(
    <KnowledgebaseGrid
      knowledgebases={data.knowledgebases}
      knowledgebaseCategories={data1.knowledgebaseCategories}
      pageIndex={1}
      setPageIndex={() => {}}
      showPagination={true}
    />
  );
};

export default SearchKnowledgebaseResults;
